import styled from "styled-components";

export const Container = styled.div`
    background: white;
    height: 30px;
    padding: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
`

export const Typography = styled.div`
    font-weight: 500;
    color: #4d4d4d;
    text-align: center;
    font-family: Hind Vadodara, Lucida Sans Unicode !important;
    letter-spacing: 0.8px;
`